import { Layout, Spin } from "antd";
import { Route, Routes, useRoutes } from "react-router-dom";
import { useState, useLayoutEffect } from "react";

// File Imports --
import PageNotFound from "../404/404Error";
import Dashboard from "../home/Dashboard";
import Login from "../auth/Login";
import Drawer from "../inc/Drawer";
import "../../App.css";
import FilesManager from "../images/FilesManager";
import CategoryAdd from "../category/CategoryAdd";
import CategoryTable from "../category/CategoryTable";
import CategoryUpdate from "../category/CategoryUpdate";
import FacilityTable from "../facility/FacilityTable";
import FacilityAdd from "../facility/FacilityAdd";
import FacilityUpdate from "../facility/FacilityUpdate";
import GalleryTable from "../gallery/GalleryTable";
import GalleryAdd from "../gallery/GalleryAdd";
import GalleryUpdate from "../gallery/GalleryUpdate";
import PagesTable from "../pages/PagesTable";
import PagesAdd from "../pages/PagesAdd";
import PagesUpdate from "../pages/PagesUpdate";
import SliderTable from "../slider/SliderTable";
import SliderAdd from "../slider/SliderAdd";
import SliderUpdate from "../slider/SliderUpdate";
import RoomTable from "../room/RoomTable";
import RoomAdd from "../room/RoomAdd";
import RoomUpdate from "../room/RoomUpdate";
import CustomerTable from "../customer/CustomerTable";
import CustomerAdd from "../customer/CustomerAdd";
import CustomerUpdate from "../customer/CustomerUpdate";
import UserTable from "../user/UserTable";
import UserAdd from "../user/UserAdd";
import UserUpdate from "../user/UserUpdate";
import Setting from "../setting/Setting";
import BookingTable from "../booking/BookingTable";
import BookingRequest from "../booking/BookingRequest";
import ProductTable from "../product/ProductTable";
import ProductAdd from "../product/ProductAdd";
import ProductUpdate from "../product/ProductUpdate";
import OrderPage from "../order/OrderPage";
import OrderTable from "../order/OrderTable";
import TeamTable from "../team/TeamTable";
import TeamAdd from "../team/TeamAdd";
import TeamUpdate from "../team/TeamUpdate";
import TestimonialTable from "../testimonial/TestimonialTable";
import TestimonialAdd from "../testimonial/TestimonialAdd";
import TestimonialUpdate from "../testimonial/TestimonialUpdate";
import ContactTable from "../contact/ContactTable";
import BlogTable from "../blog/BlogTable";
import BlogAdd from "../blog/BlogAdd";
import BlogUpdate from "../blog/BlogUpdate";
import ProfileUpdate from "../profile/ProfileUpdate";
import SeoTable from "../seo/SeoTable";
import SeoAdd from "../seo/SeoAdd";
import SeoUpdate from "../seo/SeoUpdate";
import CommonBooking from "../user-panel/booking/CommonBooking";
import LS_SERVICE from "../../utils/localStorage";
import { postAPI } from "../../utils/common";
import { USER_DETAIL } from "../../constants/api";
import BookingCalendar from "../booking/calendar/v1/BookingCalendar";
import BookingCalendarV2 from "../booking/calendar/v2/BookingCalendarV2";
import ReservationPage from "../booking/reservation/ReservationPage";
import PlaceOrderForm from "../order/PlaceOrderForm";
import ReportsPage from "../report/ReportsPage";
import ReportsPageV2 from "../report/ReportsPageV2";
import BookingReport from "../report/BookingReport";
import RoomView from "../booking/room_view/RoomView";
import ReservationTable from "../booking/reservation/ReservationTable";
import GuestsTable from "../customer/GuestsTable";
import RoomBlockedTable from "../room_blocked/RoomBlockedTable";
import RoomBlockedManage from "../room_blocked/RoomBlockedManage";
import ServiceTable from "../service/ServiceTable";
import ServiceAdd from "../service/ServiceAdd";
import ServiceUpdate from "../service/ServiceUpdate";
import RatePlan from "../rate/RatePlan";
import DBManager from "../db/DBManager";
import LogsTable from "../log/LogsTable";
import NightAudits from "../report/NightAudits";
import HotelDashboard from "../home/v2/HotelDashboard";
import VendorTable from "../laundry/Vendor/VendorTable";
import VendorAdd from "../laundry/Vendor/VendorAdd";
import VendorUpdate from "../laundry/Vendor/VendorUpdate";
import ItemTable from "../laundry/Item/ItemTable";
import ItemAdd from "../laundry/Item/ItemAdd";
import ItemUpdate from "../laundry/Item/ItemUpdate";
import LaundryOutTable from "../laundry/LaundryOut/LaundryOutTable";
import LaundryOutAdd from "../laundry/LaundryOut/LaundryOutAdd";
import LaundryInAdd from "../laundry/LaundryIn/LaundryInAdd";
import PaymentTable from "../laundry/Payment/PaymentTable";
import PaymentAdd from "../laundry/Payment/PaymentAdd";
import VendorOutstanding from "../laundry/Reports/VendorOutstanding";
import VendorLedger from "../laundry/Reports/VendorLedger";
import LaundryOutReport from "../laundry/Reports/LaundryOutReport";
import LaundryOutView from "../laundry/LaundryOut/LaundryOutView";
import StockReport from "../laundry/Stock/StockReport";
import StockLedger from "../laundry/Stock/StockLedger";
import ItemDetail from "../laundry/Item/ItemDetail";
import StockAdjustment from "../laundry/Stock/StockAdjustment";
import KitchenItemTable from "../kitchen/KitchenItemTable";
import KitchenItemAdd from "../kitchen/KitchenItemAdd";
import KitchenItemUpdate from "../kitchen/KitchenItemUpdate";
import KitchenPurchaseAdd from "../kitchen/KitchenPurchaseAdd";
import KitchenPurchaseTable from "../kitchen/KitchenPurchaseTable";
import KitchenPurchaseView from "../kitchen/KitchenPurchaseView";
import KitchenIssueAdd from "../kitchen/KitchenIssueAdd";
import KitchenIssueTable from "../kitchen/KitchenIssueTable";
import KitchenStockReport from "../kitchen/reports/StockReport";
import KitchenLowStockReport from "../kitchen/reports/LowStockReport";
import KitchenPurchaseReport from "../kitchen/reports/PurchaseReport";
import KitchenIssueReport from "../kitchen/reports/IssueReport";
import AppPageTable from "../app-pages/AppPageTable";
import AppPageAdd from "../app-pages/AppPageAdd";
import RouteGuard from "../common/RouteGuard";
import KitchenPRAdd from "../kitchen/KitchenPRAdd";
import KitchenPRTable from "../kitchen/KitchenPRTable";
import KitchenPRView from "../kitchen/KitchenPRView";
import KitchenExpStockReport from "../kitchen/reports/ExpStockReport";
import KitchenPurchaseRequestReport from "../kitchen/reports/PurchaseRequestReport";
import KitchenDailyStockReport from "../kitchen/reports/DailyStockReport";
import BookingInvoice from "../booking/BookingInvoice";
import QRScanner from "../booking/qr_pass_scanner/QRScanner";
import KitchenPurchaseReturnList from "../kitchen/KitchenPurchaseReturnList";
import KitchenPurchaseReturnView from "../kitchen/KitchenPurchaseReturnView";
import KitchenPurchaseReturnAdd from "../kitchen/KitchenPurchaseReturnAdd";
import KitchenIssueUpdate from "../kitchen/KitchenIssueUpdate";
import KitchenIssueInventory from "../kitchen/KitchenIssueInventory";

const Base = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setIsLoading] = useState(true);

  // Fetch user data from API
  const getUserData = async () => {
    const data = new FormData();
    data.append("id", LS_SERVICE.get("id"));

    const successFn = (data) => {
      if (data.status === true) {
        LS_SERVICE.set("name", data.user.name);
        LS_SERVICE.set("user_type", data.user.user_type);
        LS_SERVICE.set("phone", data.user.phone);
        LS_SERVICE.set("email", data.user.email);
        LS_SERVICE.set("isCustomer", false);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    const errorFn = () => {
      setIsLoggedIn(false);
    };

    await postAPI(USER_DETAIL, data, successFn, errorFn);
  };

  // Fetch data on component mount
  useLayoutEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      if (LS_SERVICE.get("id") && LS_SERVICE.get("user_type") !== "customer") {
        await getUserData();
      }
      setIsLoading(false);
    };

    loadData();
  }, []);

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    if (!isLoggedIn) {
      return <Login />; // Redirect to login if not logged in
    }
    return children;
  };

  function ProtectedPage({ children }) {
    return (
      <ProtectedRoute>
        <RouteGuard>{children}</RouteGuard>
      </ProtectedRoute>
    );
  }

  // Define Routes outside of conditional hooks
  const routes = [
    {
      path: "/reservation/:start_date?/:end_date?/:adult_count?/:child_count?/:room_id?",
      element: null,
    }, // No sidebar for this route
    { path: "*", element: isLoggedIn ? <Drawer /> : null }, // Render sidebar for other routes
  ];

  const match = useRoutes(routes);

  if (loading) {
    return <Spin />; // Show loading spinner until the user data is fetched
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f5f500" }}>
      {match}

      {/* Routes */}
      <Routes>
        {/* Public Route */}
        <Route
          path="/reservation/:start_date?/:end_date?/:adult_count?/:child_count?/:room_id?"
          element={<CommonBooking />}
        />
        <Route
          path="/place/order/:booking_id"
          element={<PlaceOrderForm pageFrom="c_place_order" />}
        />
        <Route path="/scan" element={<QRScanner />} />
        {/* Authenticated Routes */}
        <Route
          path="*"
          element={
            <ProtectedPage>
              <PageNotFound />
            </ProtectedPage>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedPage>
              {/* <Dashboard /> */}
              <HotelDashboard />
            </ProtectedPage>
          }
        />
        {/* Other routes wrapped in ProtectedRoute */}
        <Route
          path="/file-manager"
          element={
            <ProtectedPage>
              <FilesManager />
            </ProtectedPage>
          }
        />
        <Route
          path="/category"
          element={
            <ProtectedPage>
              <CategoryTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/category/add"
          element={
            <ProtectedPage>
              <CategoryAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/category/edit/:id"
          element={
            <ProtectedPage>
              <CategoryUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/facility"
          element={
            <ProtectedPage>
              <FacilityTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/facility/add"
          element={
            <ProtectedPage>
              <FacilityAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/facility/edit/:id"
          element={
            <ProtectedPage>
              <FacilityUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/pages-seo"
          element={
            <ProtectedPage>
              <SeoTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/pages-seo/add"
          element={
            <ProtectedPage>
              <SeoAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/pages-seo/edit/:id"
          element={
            <ProtectedPage>
              <SeoUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/gallery"
          element={
            <ProtectedPage>
              <GalleryTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/gallery/add"
          element={
            <ProtectedPage>
              <GalleryAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/gallery/edit/:id"
          element={
            <ProtectedPage>
              <GalleryUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/team"
          element={
            <ProtectedPage>
              <TeamTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/team/add"
          element={
            <ProtectedPage>
              <TeamAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/team/edit/:id"
          element={
            <ProtectedPage>
              <TeamUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/testimonial"
          element={
            <ProtectedPage>
              <TestimonialTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/testimonial/add"
          element={
            <ProtectedPage>
              <TestimonialAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/testimonial/edit/:id"
          element={
            <ProtectedPage>
              <TestimonialUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/pages"
          element={
            <ProtectedPage>
              <PagesTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/pages/add"
          element={
            <ProtectedPage>
              <PagesAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/pages/edit/:id"
          element={
            <ProtectedPage>
              <PagesUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/slider"
          element={
            <ProtectedPage>
              <SliderTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/slider/add"
          element={
            <ProtectedPage>
              <SliderAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/slider/edit/:id"
          element={
            <ProtectedPage>
              <SliderUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/service"
          element={
            <ProtectedPage>
              <ServiceTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/service/add"
          element={
            <ProtectedPage>
              <ServiceAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/service/edit/:id"
          element={
            <ProtectedPage>
              <ServiceUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/room"
          element={
            <ProtectedPage>
              <RoomTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/room/add/:id?"
          element={
            <ProtectedPage>
              <RoomAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/room/edit/:id"
          element={
            <ProtectedPage>
              <RoomUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/room/blocked/:id"
          element={
            <ProtectedPage>
              <RoomBlockedTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/room/blocked/manage/:room_id?/:edit_id?"
          element={
            <ProtectedPage>
              <RoomBlockedManage />
            </ProtectedPage>
          }
        />
        <Route
          path="/customer"
          element={
            <ProtectedPage>
              <CustomerTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/customer/add"
          element={
            <ProtectedPage>
              <CustomerAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/customer/edit/:id"
          element={
            <ProtectedPage>
              <CustomerUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/contacts"
          element={
            <ProtectedPage>
              <ContactTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/blog"
          element={
            <ProtectedPage>
              <BlogTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/blog/add"
          element={
            <ProtectedPage>
              <BlogAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/blog/edit/:id"
          element={
            <ProtectedPage>
              <BlogUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedPage>
              <UserTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/user/add"
          element={
            <ProtectedPage>
              <UserAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/user/edit/:id"
          element={
            <ProtectedPage>
              <UserUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/order"
          element={
            <ProtectedPage>
              <OrderTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/order/product/:booking_id"
          element={
            <ProtectedPage>
              <OrderPage />
            </ProtectedPage>
          }
        />
        <Route
          path="/product"
          element={
            <ProtectedPage>
              <ProductTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/product/add"
          element={
            <ProtectedPage>
              <ProductAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/product/edit/:id"
          element={
            <ProtectedPage>
              <ProductUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/setting"
          element={
            <ProtectedPage>
              <Setting />
            </ProtectedPage>
          }
        />
        <Route
          path="/profile/update"
          element={
            <ProtectedPage>
              <ProfileUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/room-view"
          element={
            <ProtectedPage>
              <RoomView />
            </ProtectedPage>
          }
        />
        <Route
          path="/booking-calendar"
          element={
            <ProtectedPage>
              <BookingCalendar />
            </ProtectedPage>
          }
        />
        <Route
          path="/stay-view"
          element={
            <ProtectedPage>
              <BookingCalendarV2 />
            </ProtectedPage>
          }
        />
        <Route
          path="/guests"
          element={
            <ProtectedPage>
              <GuestsTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/reservation-data"
          element={
            <ProtectedPage>
              <ReservationTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/booking-reservation"
          element={
            <ProtectedPage>
              <ReservationPage />
            </ProtectedPage>
          }
        />
        <Route
          path="/booking"
          element={
            <ProtectedPage>
              <BookingTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/booking/invoice"
          element={
            <ProtectedPage>
              <BookingInvoice />
            </ProtectedPage>
          }
        />
        <Route
          path="/booking-request"
          element={
            <ProtectedPage>
              <BookingRequest />
            </ProtectedPage>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedPage>
              <ReportsPage />
            </ProtectedPage>
          }
        />
        <Route
          path="/reports-v2"
          element={
            <ProtectedPage>
              <ReportsPageV2 />
            </ProtectedPage>
          }
        />
        <Route
          path="/booking-reports"
          element={
            <ProtectedPage>
              <BookingReport />
            </ProtectedPage>
          }
        />
        <Route
          path="/night-audit"
          element={
            <ProtectedPage>
              <NightAudits />
            </ProtectedPage>
          }
        />
        <Route
          path="/ota-rate-plan"
          element={
            <ProtectedPage>
              <RatePlan />
            </ProtectedPage>
          }
        />
        <Route
          path="/db-manage"
          element={
            <ProtectedPage>
              <DBManager />
            </ProtectedPage>
          }
        />
        <Route
          path="/external-logs"
          element={
            <ProtectedPage>
              <LogsTable />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/vendor"
          element={
            <ProtectedPage>
              <VendorTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/vendor/add"
          element={
            <ProtectedPage>
              <VendorAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/vendor/edit/:id"
          element={
            <ProtectedPage>
              <VendorUpdate />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/item"
          element={
            <ProtectedPage>
              <ItemTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/item/add"
          element={
            <ProtectedPage>
              <ItemAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/item/edit/:id"
          element={
            <ProtectedPage>
              <ItemUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/item/view/:id"
          element={
            <ProtectedPage>
              <ItemDetail />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/out"
          element={
            <ProtectedPage>
              <LaundryOutTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/out/add"
          element={
            <ProtectedPage>
              <LaundryOutAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/in/add/:laundry_out_id"
          element={
            <ProtectedPage>
              <LaundryInAdd />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/out/view/:id"
          element={
            <ProtectedPage>
              <LaundryOutView />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/payment"
          element={
            <ProtectedPage>
              <PaymentTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/payment/add"
          element={
            <ProtectedPage>
              <PaymentAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/report/outstanding"
          element={
            <ProtectedPage>
              <VendorOutstanding />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/report/ledger"
          element={
            <ProtectedPage>
              <VendorLedger />
            </ProtectedPage>
          }
        />
        <Route
          path="/laundry/report/laundry-out"
          element={
            <ProtectedPage>
              <LaundryOutReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/stock"
          element={
            <ProtectedPage>
              <StockReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/stock-ledger"
          element={
            <ProtectedPage>
              <StockLedger />
            </ProtectedPage>
          }
        />

        <Route
          path="/laundry/stock-adjust"
          element={
            <ProtectedPage>
              <StockAdjustment />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/item"
          element={
            <ProtectedPage>
              <KitchenItemTable />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/item/add"
          element={
            <ProtectedPage>
              <KitchenItemAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/item/edit/:id"
          element={
            <ProtectedPage>
              <KitchenItemUpdate />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase/add"
          element={
            <ProtectedPage>
              <KitchenPurchaseAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase"
          element={
            <ProtectedPage>
              <KitchenPurchaseTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/purchase/view/:id"
          element={
            <ProtectedPage>
              <KitchenPurchaseView />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase-request/add"
          element={
            <ProtectedPage>
              <KitchenPRAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase-request"
          element={
            <ProtectedPage>
              <KitchenPRTable />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase-request/view/:id"
          element={
            <ProtectedPage>
              <KitchenPRView />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase-return"
          element={
            <ProtectedPage>
              <KitchenPurchaseReturnList />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase-return/add"
          element={
            <ProtectedPage>
              <KitchenPurchaseReturnAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/purchase-return/view/:id"
          element={
            <ProtectedPage>
              <KitchenPurchaseReturnView />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/issue/add"
          element={
            <ProtectedPage>
              <KitchenIssueAdd />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/issue"
          element={
            <ProtectedPage>
              <KitchenIssueTable />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/issue/remaining"
          element={
            <ProtectedPage>
              <KitchenIssueUpdate />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/issue/inventory"
          element={
            <ProtectedPage>
              <KitchenIssueInventory />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/report/stock"
          element={
            <ProtectedPage>
              <KitchenStockReport />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/report/low-stock"
          element={
            <ProtectedPage>
              <KitchenLowStockReport />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/report/exp-stock"
          element={
            <ProtectedPage>
              <KitchenExpStockReport />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/report/daily-stock"
          element={
            <ProtectedPage>
              <KitchenDailyStockReport />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/report/purchase-request"
          element={
            <ProtectedPage>
              <KitchenPurchaseRequestReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/kitchen/report/purchase"
          element={
            <ProtectedPage>
              <KitchenPurchaseReport />
            </ProtectedPage>
          }
        />
        <Route
          path="/kitchen/report/issue"
          element={
            <ProtectedPage>
              <KitchenIssueReport />
            </ProtectedPage>
          }
        />

        <Route
          path="/app-pages"
          element={
            <ProtectedPage>
              <AppPageTable />
            </ProtectedPage>
          }
        />
        <Route
          path="/app-pages/add"
          element={
            <ProtectedPage>
              <AppPageAdd />
            </ProtectedPage>
          }
        />
      </Routes>
    </Layout>
  );
};

export default Base;
